import { Col, Label, Panel, Row } from 'react-bootstrap';
import { IEpletMismatch } from '@nkr/models/index';
import MismatchEpletDetails from '@nkr/views/swap-management/mismatch-eplet-details';

interface IProps {
    recipientId: number,
    donorId: number,
    recipientAlias: string,
    donorAlias: string,
    epletMismatches: IEpletMismatch[]
}

const MismatchResults = (props: IProps) => {
    let mismatch0Count = props.epletMismatches.filter(x => x.geneGroupId == 0).length;
    let mismatch1Count = props.epletMismatches.filter(x => x.geneGroupId == 1).length;
    let mismatch2Count = props.epletMismatches.filter(x => x.geneGroupId == 2).length;
    let mismatch3Count = props.epletMismatches.filter(x => x.geneGroupId == 3).length;
    let mismatch4Count = props.epletMismatches.filter(x => x.geneGroupId == 4).length;
    let mismatch5Count = props.epletMismatches.filter(x => x.geneGroupId == 5).length;

    let totalMismatchCount = mismatch0Count + mismatch1Count + mismatch2Count + mismatch3Count + mismatch4Count + mismatch5Count;

    let geneGroup0 = props.epletMismatches.filter(x => x.geneGroupId == 0);
    let geneGroup1 = props.epletMismatches.filter(x => x.geneGroupId == 1);
    let geneGroup2 = props.epletMismatches.filter(x => x.geneGroupId == 2);
    let geneGroup3 = props.epletMismatches.filter(x => x.geneGroupId == 3);
    let geneGroup4 = props.epletMismatches.filter(x => x.geneGroupId == 4);
    let geneGroup5 = props.epletMismatches.filter(x => x.geneGroupId == 5);

    return (

        <div className='row'>
            <div className='col-xs-12'>
                <Panel bsStyle="primary">
                    <Panel.Heading>
                        Mismatch Results
                        <span className=' badge mmcounter pull-right'>
                            {totalMismatchCount} mismatches
                        </span>
                    </Panel.Heading>
                    <Panel.Body>
                        <div>
                            <Row className="no-print">
                                <Col xs={12} sm={6}>
                                    <p className="small">click eplet results for additional details</p>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <div className="pull-right">
                                        <Label bsStyle="danger">&nbsp;</Label> antibody verified
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <Col xs={12} sm={3} className="eplet-container" id="mismatch_0">
                                        <h4 className="heading">Class I Eplets <span className="badge mmcounter">{mismatch0Count}</span></h4>

                                        {geneGroup0.map((epletMismatch, index) =>
                                            <MismatchEpletDetails key={'gene-group-0-' + index} eplet={epletMismatch} dismiss={true} isAdmin={false} placement='top' />
                                        )}
                                    </Col>
                                    <Col xs={12} sm={3} className="eplet-container" id="mismatch_1">
                                        <h4 className="heading">HLA-DRB Eplets <span className="badge mmcounter">{mismatch1Count}</span></h4>

                                        {geneGroup1.map((epletMismatch, index) =>
                                            <MismatchEpletDetails key={'gene-group-1-' + index} eplet={epletMismatch} dismiss={true} isAdmin={false} placement='top' />
                                        )}
                                    </Col>
                                    <Col xs={12} sm={3}>
                                        <Col xs={12} className="eplet-container" id="mismatch_2" style={{ marginBottom: '30px' }}>
                                            <h4 className="heading">HLA-DQA Eplets <span className="badge mmcounter">{mismatch2Count}</span></h4>

                                            {geneGroup2.map((epletMismatch, index) =>
                                                <MismatchEpletDetails key={'gene-group-2-' + index} eplet={epletMismatch} dismiss={true} isAdmin={false} placement='top' />
                                            )}
                                        </Col>
                                        <Col xs={12} className="eplet-container" id="mismatch_3">
                                            <h4 className="heading">HLA-DQB Eplets <span className="badge mmcounter">{mismatch3Count}</span></h4>

                                            {geneGroup3.map((epletMismatch, index) =>
                                                <MismatchEpletDetails key={'gene-group-3-' + index} eplet={epletMismatch} dismiss={true} isAdmin={false} placement='top' />
                                            )}
                                        </Col>
                                    </Col>
                                    <Col xs={12} sm={3}>
                                        <Col xs={12} className="eplet-container" id="mismatch_4" style={{ marginBottom: '30px' }}>
                                            <h4 className="heading">HLA-DPA Eplets <span className="badge mmcounter">{mismatch4Count}</span></h4>

                                            {geneGroup4.map((epletMismatch, index) =>
                                                <MismatchEpletDetails key={'gene-group-4-' + index} eplet={epletMismatch} dismiss={true} isAdmin={false} placement='top' />
                                            )}
                                        </Col>
                                        <Col xs={12} className="eplet-container" id="mismatch_5">
                                            <h4 className="heading">HLA-DPB Eplets <span className="badge mmcounter">{mismatch5Count}</span></h4>

                                            {geneGroup5.map((epletMismatch, index) =>
                                                <MismatchEpletDetails key={'gene-group-5-' + index} eplet={epletMismatch} dismiss={true} isAdmin={false} placement='top' />
                                            )}
                                        </Col>
                                    </Col>
                                </Col>
                            </Row>
                        </div>
                    </Panel.Body>
                </Panel>
            </div>
        </div>
    );
}

export default MismatchResults;